const parseEvent = (event) => {
  const isCorrectOrigin = event.origin === process.env.REACT_APP_APP_URL;
  if (isCorrectOrigin === false) {
    return null;
  }
  try {
    const payload = JSON.parse(event.data);
    return payload;
  } catch (error) {
    return null;
  }
};

export const initiateOAuth = (oauthUrl) => {
  const redirectUrl = `${process.env.REACT_APP_APP_URL}/#/settings/integrations/callbacks/oauth`;
  const fullUrl = `${oauthUrl}${encodeURIComponent(redirectUrl)}`;
  return new Promise((resolve, reject) => {
    const popup = window.open(fullUrl, 'popup', 'height=600,width=600');
    // https://stackoverflow.com/a/48240128
    const closedCheckTimer = setInterval(() => {
      if (popup.closed) {
        clearInterval(closedCheckTimer);
        reject('Authentication not completed');
      }
    }, 500);
    const messageListener = (event) => {
      const payload = parseEvent(event);
      if (payload === null) {
        return;
      }
      const { type, code } = payload;
      if (type !== 'oauth-callback') {
        return;
      }
      resolve(code);
      window.removeEventListener('message', messageListener);
      clearInterval(closedCheckTimer);
      popup.close();
    };
    window.addEventListener('message', messageListener);
  });
};
